import React from "react";
import {
  Navbar,
  MobileNav,
  Typography,
  Menu,
  MenuHandler,
  MenuItem,
  IconButton,
} from "@material-tailwind/react";
import {

  Bars2Icon,
} from "@heroicons/react/24/outline";

import { FaFacebook,FaInstagram } from 'react-icons/fa';
import Logo from '../../images/logo.png'
import { Link, useLocation } from 'react-router-dom'; 


function ProfileMenu() {

  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
  
  <Menu open={isMenuOpen} handler={setIsMenuOpen} placement="bottom-end">
      <MenuHandler>
        <button
          variant="text"
         
          className="flex items-center gap-1 py-0.5 pr-2 pl-0.5 lg:ml-auto"
        >
           <div className="flex items-center gap-4">
      
      <IconButton variant="text" className="rounded-full">
       <FaFacebook size={20} color="#0D8AF1" />
      </IconButton>
      <IconButton variant="text" className="rounded-full">
        <FaInstagram size={20}  color="#F7085F" />
      </IconButton>
    </div>
         
        </button>
      </MenuHandler>
   
    </Menu>
  );
}

 

 
// nav list component
const navListItems = [
    {
      label: 'Home',
      path: '/',
    },
    {
      label: 'About Us',
     
      path: '/about',
    },
    {
      label: 'Product',
      path: '/product',
    },
    {
      label: 'Contact Us',
      path: '/contact',
    },
  ];
 
function NavList() {
    const location = useLocation(); // Use useLocation() hook to get the current location

    return (
      <ul className="mb-4 mt-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center">
        {navListItems.map(({ label, path }, key) => (
    
           

            <Typography
          key={label}
          as="a"
          href="#"
          variant="small"
          color="blue-gray"
          className="font-normal"
        >
          <MenuItem className="flex  hover:bg-yellow-600  items-center gap-2 lg:rounded-full">
          <Link
              to={path}
             
              className={`nav-item text-green-700 font-bold text-lg  ${
                location.pathname === path ? 'text-yellow-700 hover:text-green-400' : ''
              }`}
            >
              {label}
            </Link>
        
          </MenuItem>
        </Typography>

      
        ))}
      </ul>
    );
  }
 
export default function ComplexNavbar() {
  const [isNavOpen, setIsNavOpen] = React.useState(false);
 
  const toggleIsNavOpen = () => setIsNavOpen((cur) => !cur);
 
  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setIsNavOpen(false),
    );
  }, []);
 
  return (
    <>
    <Navbar color="#FFFFFF" className="sticky top-0 z-40 h-max max-w-full  rounded-none py-2 px-4 lg:px-8 lg:py-4">
      <div className="relative mx-auto flex items-center text-blue-gray-900">
        <Typography
          as="a"
          href="#"
          className="mr-4 ml-2 cursor-pointer py-1.5 font-bold"
        >
         <img src={Logo} className="object-fit h-10 w-24" alt="" srcset="" />
        </Typography>
        <div className="absolute top-2/4 left-2/4 hidden -translate-x-2/4 -translate-y-2/4 lg:block font-bold">
          <NavList />
        </div>
        <IconButton
          size="sm"
          color="blue-gray"
          variant="text"
          onClick={toggleIsNavOpen}
          className="ml-auto mr-2 lg:hidden"
        >
          <Bars2Icon className="h-6 w-6" />
        </IconButton>
        <ProfileMenu />
      </div>
      <MobileNav open={isNavOpen} className="overflow-scroll">
        <NavList />
      </MobileNav>
    </Navbar>

</>

  );
}